import { Modal, btnTurq } from "../bits";
import { API } from "../../lib/api";
import { Upload, Eye, Trash2 } from "lucide-react";

const ATTACH_KINDS = [
  { key: "brief", label: "شاهد بيانات الفرصة" },
  { key: "closure", label: "مرفق بعد إغلاق الفرصة" },
  { key: "final_report", label: "تقرير الختام" },
];

export function OppAttsModal({ open, opp, onClose, busy, onUpload, onRemove }) {
  return (
    <Modal open={open} onClose={onClose} title={`مرفقات «${opp?.name || ""}»`} testid="attachments-modal">
      <div className="space-y-3">
        {ATTACH_KINDS.map((k) => {
          const att = ((opp?.attachments) || {})[k.key];
          return (
            <div key={k.key} data-testid={`attach-row-${k.key}`} className="rounded-xl border border-brd p-3 bg-bg/50">
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <div className="font-bold text-[13px]">{k.label}</div>
                <div className="flex items-center gap-3">
                  {att && (
                    <>
                      <a data-testid={`attach-view-${k.key}`} target="_blank" rel="noreferrer"
                        href={`${API}/portal/opportunities/${opp.id}/attachments/${k.key}`}
                        className="text-[11px] font-bold text-turq-600 hover:text-turq-900 flex items-center gap-1">
                        <Eye className="w-3.5 h-3.5" /> عرض
                      </a>
                      <button data-testid={`attach-delete-${k.key}`} onClick={() => onRemove(k.key)}
                        className="text-coral-900 dark:text-coral-300 hover:scale-110 transition-transform">
                        <Trash2 className="w-3.5 h-3.5" />
                      </button>
                    </>
                  )}
                  <label data-testid={`attach-upload-${k.key}`}
                    className={`${btnTurq} cursor-pointer ${busy ? "opacity-50 pointer-events-none" : ""}`}>
                    <Upload className="w-3.5 h-3.5" /> {att ? "استبدال" : "رفع"}
                    <input type="file" accept="image/*,application/pdf" hidden
                      onChange={(e) => { onUpload(k.key, e.target.files?.[0]); e.target.value = ""; }} />
                  </label>
                </div>
              </div>
              <p className="text-[10px] text-mutext mt-1.5">الصيغ المقبولة: JPG، PNG، WEBP، أو PDF — بحد أقصى 3 ميجابايت</p>
              {att && <p className="text-[10px] text-turq-600 mt-0.5 truncate" dir="ltr">{att.filename}</p>}
            </div>
          );
        })}
      </div>
    </Modal>
  );
}
